import { mapStore } from "../store";

export const updateShouldSyncUrl = (shouldSyncUrl: boolean) => {
  mapStore.shouldSyncUrl = shouldSyncUrl;
};
